import request from "@helpers/request"


function fetchCounter(config) {
    return request.forBaseUrl()
        .withHeaders({ "Content-Type": "application/json" })
        .build().get(`/v1/counter`, {}, { ...config });
}
function fetchSimpleCounter(config) {
    return request.forBaseUrl()
        .withHeaders({ "Content-Type": "application/json" })
        .build().get(`/v1/counter/simple`, {}, { ...config });
}

const counterService = {
    fetchCounter,
    fetchSimpleCounter,
}

export default counterService